import StatusBadge from "../../../intelligence/StatusBadge";

const LABELS = {
  fresh: "Fresh",
  stale: "Stale",
  down: "Down",
  experimental: "Experimental",
  historical: "Historical",
  unknown: "Unknown",
  no_data: "No data",
  disabled: "Disabled",
  warning: "Warning",
  configured: "Configured",
  not_configured: "Not configured",
  CONFIGURED: "Configured",
  NOT_CONFIGURED: "Not configured",
  DISABLED: "Disabled",
  HEALTHY: "Healthy",
  DEGRADED: "Degraded",
  UNREACHABLE: "Unreachable",
  TIMEOUT: "Timeout",
  INVALID_RESPONSE: "Invalid response",
  INVALID_LAYER: "Invalid layer",
  DISCOVERED: "Discovered",
  DISCOVERED_WITH_WARNINGS: "Discovered (warnings)",
  NO_CANDIDATES_FOUND: "No candidates",
  healthy: "Healthy",
  degraded: "Degraded",
  stale: "Stale",
  unavailable: "Unavailable",
  empty: "Empty",
  partial: "Partial",
  fallback_active: "Fallback active",
  disabled: "Disabled",
  error: "Error",
  unknown: "Unknown",
  requires_access: "Requires access",
  approved_development: "Approved for development",
  not_live: "Not live",
  planned: "Planned",
};

const TONES = {
  fresh: "confirmed",
  stale: "medium",
  down: "disputed",
  experimental: "neutral",
  historical: "neutral",
  unknown: "neutral",
  no_data: "medium",
  disabled: "neutral",
  warning: "medium",
  configured: "confirmed",
  not_configured: "medium",
  CONFIGURED: "confirmed",
  NOT_CONFIGURED: "medium",
  DISABLED: "neutral",
  HEALTHY: "confirmed",
  DEGRADED: "medium",
  UNREACHABLE: "disputed",
  TIMEOUT: "disputed",
  INVALID_RESPONSE: "disputed",
  INVALID_LAYER: "disputed",
  DISCOVERED: "confirmed",
  DISCOVERED_WITH_WARNINGS: "medium",
  NO_CANDIDATES_FOUND: "medium",
  healthy: "confirmed",
  degraded: "medium",
  stale: "medium",
  unavailable: "disputed",
  empty: "medium",
  partial: "medium",
  fallback_active: "medium",
  disabled: "neutral",
  error: "disputed",
  unknown: "neutral",
  requires_access: "medium",
  approved_development: "confirmed",
  not_live: "neutral",
  planned: "neutral",
};

const WeatherHealthBadge = ({ status }) => {
  const normalized = String(status || "unknown").toLowerCase();

  return (
    <span className={`weather-health-badge weather-health-badge--${normalized}`}>
      <StatusBadge
        label={LABELS[normalized] || normalized.replace(/_/g, " ")}
        tone={TONES[normalized] || "neutral"}
      />
    </span>
  );
};

export default WeatherHealthBadge;
